interface WindowWithForter extends Window {
  ccForterToken?: () => string | null;
}

export function getForterToken(): string | null {
  try {
    if (typeof window === "undefined") {
      return null;
    }

    const reader = (window as unknown as WindowWithForter).ccForterToken;

    return typeof reader === "function" ? reader() : null;
  } catch {
    return null;
  }
}
